import { jsx as _jsx } from "react/jsx-runtime";

function MetaRobots({
  directive
}) {
  const content = Array.isArray(directive) ? directive.join(',') : directive;
  return /*#__PURE__*/_jsx("meta", {
    name: "robots",
    content: content
  });
}

export default MetaRobots;